function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import changeReducerFactory from './changeReducerFactory';
import detailReducerFactory from './detailReducerFactory';
import documentConstantsFactory from '../../constants/documentConstantsFactory';
import entityReducerFactory from './entityReducerFactory';
import { reduceReducers } from '../applyReducer';
import uploadReducerFactory from './uploadReducerFactory';
const documentReducerFactory = (entity, paged = true) => {
  const entityReducer = entityReducerFactory(entity);
  const changeReducer = changeReducerFactory(entity);
  const detailReducer = detailReducerFactory(entity);
  const uploadReducer = uploadReducerFactory(entity);
  const documentConstants = documentConstantsFactory(entity);
  const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.initState), detailReducer.initState), entityReducer.initState), uploadReducer.initState), {}, {
    failedToUpload: [],
    lastUploadedDocs: [],
    pendingDocs: [],
    permissions: {
      view: {
        exclude: ['read_only']
      },
      edit: {
        include: ['user_edit', 'job_edit']
      }
    },
    progress: -1,
    // hides progress bar
    selectError: null,
    selectingAssociations: false,
    selections: [],
    // selections
    selectLoading: false,
    // selectLoading
    uploadError: null,
    downloadPDF: null
  });
  if (!paged) {
    // clear paging from state
    const noPagingIndexQuery = _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), {}, {
      paging: null
    });
    initState.indexQuery = noPagingIndexQuery;
    initState.initialIndexQuery = noPagingIndexQuery;
  }
  const saveAllSuccess = state => {
    /* 95%  - indicates that all files have been uploaded to S3 and now
              records need to be saved to the database
       100% - indicates that all uploads have completed AND records have been
              saved to the database
     */
    let newProgress = state.progress;
    let lastUploadedDocs = [];
    if (newProgress === 95) {
      newProgress = 100;
      lastUploadedDocs = state.pendingDocs; // preserve the list of upload docs
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      lastUploadedDocs,
      progress: newProgress,
      pendingDocs: []
    });
  };
  const selectingAssociations = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectingAssociations: action.selecting
  });
  const renderSuccess = (state, action) => {
    const {
      formDocument,
      renderedDocument
    } = action;
    return _objectSpread(_objectSpread({}, state), {}, {
      active: {
        formDocument,
        renderedDocument
      },
      error: null
    });
  };
  const reset = state => _objectSpread(_objectSpread({}, state), {}, {
    active: null,
    error: null
  });
  const downloadClear = state => _objectSpread(_objectSpread({}, state), {}, {
    downloadPDF: null,
    error: null
  });
  const downloadFailure = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    error: action.error
  });
  const downloadSuccess = (state, action) => {
    const {
      renderedDocument
    } = action;
    return _objectSpread(_objectSpread({}, state), {}, {
      downloadPDF: renderedDocument.pdfPath,
      error: null
    });
  };
  const render = state => _objectSpread(_objectSpread({}, state), {}, {
    active: null,
    error: null
  });
  const renderFailure = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    error: action.error
  });
  const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.reducers), detailReducer.reducers), entityReducer.reducers), uploadReducer.reducers), {}, {
    [documentConstants.SAVE_ALL_SUCCESS]: reduceReducers(changeReducer.reducers[documentConstants.SAVE_ALL_SUCCESS], saveAllSuccess),
    [documentConstants.SELECTING_ASSOCIATIONS]: selectingAssociations,
    [documentConstants.DOWNLOAD_CLEAR]: downloadClear,
    [documentConstants.DOWNLOAD_SUCCESS]: downloadSuccess,
    [documentConstants.DOWNLOAD_FAILURE]: downloadFailure,
    [documentConstants.RESET]: reset,
    [documentConstants.RENDER_FAILURE]: renderFailure,
    [documentConstants.RENDER_SUCCESS]: renderSuccess,
    [documentConstants.RENDER]: render
  });

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers,
    initState
  };
};
export default documentReducerFactory;